import "./styles/global.css";

import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import axios from "axios";
import VueAxios from "vue-axios";
import VueSweetalert2 from "vue-sweetalert2";
import Swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
import "@/plugins/axios";

Vue.use(VueAxios, axios);
Vue.use(VueSweetalert2);

Vue.prototype.$domain_api = process.env.VUE_APP_API_URL;
Vue.prototype.$axios = axios;
Vue.prototype.$swal = Swal;

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
